import { Link } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaYoutube, FaPhone } from 'react-icons/fa'
import { useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'

const SuccessPage = () => {
    const { t } = useTranslation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <section className="min-h-screen bg-black flex flex-col items-center justify-center px-4 text-center">
            {/* Logo */}
            <div className="mb-12">
                <img
                    src="/logo.webp"
                    alt={t('success.logo_alt', 'JD Rivero Logo')}
                    className="w-48 sm:w-64 object-contain"
                />
            </div>

            {/* Success Message */}
            <div className="max-w-2xl mx-auto space-y-6 mb-16">
                <h1 className="text-4xl sm:text-5xl font-black text-white uppercase tracking-widest">
                    {t('success.title')}
                </h1>
                <p className="text-xl text-gray-400 leading-relaxed font-light">
                    <Trans i18nKey="success.message" />
                </p>

                <div className="pt-8 border-t border-gray-800">
                    <p className="text-lg text-white font-medium mb-6">
                        {t('success.urgent_message')}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                        <a href="tel:+12144620683" className="flex items-center gap-3 px-6 py-3 bg-gray-900 border border-gray-700 rounded-lg hover:border-primary hover:text-white transition group w-full sm:w-auto justify-center">
                            <FaPhone className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
                            <span className="text-gray-300 group-hover:text-white"><span className="text-gray-500 font-bold text-[10px] mr-2 uppercase tracking-tighter">{t('regions.texas')}</span>(214) 462 0683</span>
                        </a>
                        <a href="tel:+17862961439" className="flex items-center gap-3 px-6 py-3 bg-gray-900 border border-gray-700 rounded-lg hover:border-primary hover:text-white transition group w-full sm:w-auto justify-center">
                            <FaPhone className="h-5 w-5 text-primary group-hover:scale-110 transition-transform" />
                            <span className="text-gray-300 group-hover:text-white"><span className="text-gray-500 font-bold text-[10px] mr-2 uppercase tracking-tighter">{t('regions.florida')}</span>(786) 296 1439</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Social Media Links */}
            <div className="flex gap-8 mb-16">
                <a
                    href="https://www.facebook.com/jdriveroinc/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-transform hover:scale-110"
                >
                    <FaFacebook className="text-3xl" />
                </a>
                <a
                    href="https://www.instagram.com/stories/highlights/18076407466817371/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-transform hover:scale-110"
                >
                    <FaInstagram className="text-3xl" />
                </a>
                <a
                    href="https://www.youtube.com/@jdrivero4394"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition-transform hover:scale-110"
                >
                    <FaYoutube className="text-3xl" />
                </a>
            </div>

            {/* Go to Home Button */}
            <Link
                to="/"
                className="bg-primary hover:bg-yellow-400 text-black px-10 py-4 rounded-full font-bold uppercase tracking-[0.2em] transition-all hover:scale-105 shadow-lg shadow-primary/20"
            >
                {t('success.home_button')}
            </Link>
        </section>
    )
}

export default SuccessPage
